module.exports = __webpack_public_path__ + "img/by.0e11c235.svg";